var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12C1.94772 12 1.5 12.4477 1.5 13H0.5C0.5 11.8954 1.39543 11 2.5 11C3.09735 11 3.63353 11.2619 4 11.6771C4.36647 11.2619 4.90265 11 5.5 11C6.09735 11 6.63353 11.2619 7 11.6771C7.36647 11.2619 7.90265 11 8.5 11C9.09735 11 9.63353 11.2619 10 11.6771C10.3665 11.2619 10.9027 11 11.5 11C12.6046 11 13.5 11.8954 13.5 13H12.5C12.5 12.4477 12.0523 12 11.5 12C10.9477 12 10.5 12.4477 10.5 13H9.5C9.5 12.4477 9.05228 12 8.5 12C7.94772 12 7.5 12.4477 7.5 13H6.5C6.5 12.4477 6.05228 12 5.5 12C4.94772 12 4.5 12.4477 4.5 13H3.5C3.5 12.4477 3.05228 12 2.5 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5524 10.0005C11.4705 4.83571 8.57105 1.4142 4.00003 0.5C5.89862 5.05662 4.81737 8.2675 3.38428 10.1327C3.60106 10.1995 3.80736 10.2902 4.00003 10.4016C4.44117 10.1465 4.95372 10 5.50003 10C6.04634 10 6.5589 10.1465 7.00003 10.4016C7.44117 10.1465 7.95372 10 8.50003 10C9.04634 10 9.5589 10.1465 10 10.4016C10.4412 10.1465 10.9537 10 11.5 10C11.5175 10 11.535 10.0002 11.5524 10.0005Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShark);
export default __webpack_public_path__ + "static/media/shark.9db62445.svg";
export { ForwardRef as ReactComponent };